import React from "react";

import { Text } from "@performyard/py-components";

import { KPICard } from "../components/KPICard";

import { useSurveyResultsKPIs } from "../hooks/useSurveyResultsKPIs";

export const SurveyResultsKPIs = ({ surveyId }: { surveyId: string }) => {
	const { currentPeriod, participantSubmissions, questionsAnswered, isLoading } = useSurveyResultsKPIs({ surveyId });
	return (
		<div data-testid="survey-results-kpis" className="flex gap-4">
			<KPICard
				title={
					<span className="flex items-center gap-1">
						<Text size="paragraph-3" weight="regular">
							Current Survey
						</Text>
						<Text size="paragraph-3" weight="semi-bold">
							Period
						</Text>
					</span>
				}
				info="Displays information related to the survey schedule and availability"
				counter={currentPeriod.value}
				description={currentPeriod.label}
				isLoading={isLoading}
				testId="current-survey-period"
			/>
			<KPICard
				title={
					<span className="flex items-center gap-1">
						<Text size="paragraph-3" weight="regular">
							Participant
						</Text>
						<Text size="paragraph-3" weight="semi-bold">
							Submission
						</Text>
					</span>
				}
				info="Displays the count of employees who have participated in the survey"
				counter={participantSubmissions.value}
				description={participantSubmissions.label}
				isLoading={isLoading}
				testId="participant-submissions"
			/>
			<KPICard
				title={
					<span className="flex items-center gap-1">
						<Text size="paragraph-3" weight="regular">
							Questions
						</Text>
						<Text size="paragraph-3" weight="semi-bold">
							Answered
						</Text>
					</span>
				}
				info="Displays the question response rate for the survey"
				counter={questionsAnswered.value}
				description={questionsAnswered.label}
				type="percentage"
				isLoading={isLoading}
				testId="questions-answered"
			/>
		</div>
	);
};
